var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddOn = function SvgAddOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 15.808h1.5V12.75h3.058v-1.5H12.75V8.192h-1.5v3.058H8.192v1.5h3.058zM12 21.5q-.361 0-.69-.128a1.7 1.7 0 0 1-.594-.399L3.058 13.3a2.4 2.4 0 0 1-.407-.61 1.64 1.64 0 0 1 0-1.375q.15-.335.407-.59l7.658-7.673a1.9 1.9 0 0 1 .601-.417Q11.638 2.5 12 2.5q.352 0 .693.135.342.136.597.417l7.643 7.673q.265.27.416.597.15.325.151.678 0 .361-.143.69-.144.33-.424.61l-7.643 7.673q-.256.255-.597.392-.34.135-.693.135m.23-1.596 7.649-7.663a.32.32 0 0 0 .086-.236q0-.15-.086-.236L12.23 4.106a.32.32 0 0 0-.236-.087q-.15 0-.236.087l-7.647 7.663a.34.34 0 0 0-.077.236q0 .15.077.236l7.647 7.663a.34.34 0 0 0 .236.077q.15 0 .236-.077"
  })));
};
export default SvgAddOn;